import { Capacitor } from '@capacitor/core';
import { ChottuLinkIonicSDK } from 'capacitor-chottulink-sdk';
import { getEnv } from '@/shared/utils/get-env';
import { handleAppOpenUrl } from '@/core/plugins/capacitor/deeplinks';

const resolveInviteUrlFromChottuPayload = (data: {
  url?: string;
  metadata?: Record<string, unknown>;
}): string | null => {
  const shortLinkRaw = (data.metadata?.shortLinkRaw as string | undefined) || null;
  const originalURL = (data.metadata?.originalURL as string | undefined) || null;
  const resolvedUrl = data.url || originalURL || shortLinkRaw;

  return resolvedUrl || null;
};

export const ChottuLinkPlugin = {
  install() {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    void (async () => {
      let apiKey: string;

      try {
        apiKey = getEnv('CHOTTULINK_MOBILE_SDK_KEY');
      } catch {
        console.warn('ChottuLink: CHOTTULINK_MOBILE_SDK_KEY is not set, skip init');

        return;
      }

      try {
        await ChottuLinkIonicSDK.initialize({
          apiKey,
        });

        await ChottuLinkIonicSDK.addListener('onDeepLinkResolved', (data) => {
          const resolvedUrl = resolveInviteUrlFromChottuPayload(data);

          if (!resolvedUrl) {
            return;
          }

          handleAppOpenUrl(resolvedUrl);
        });

        await ChottuLinkIonicSDK.addListener('onDeepLinkFailed', (data) => {
          console.error('ChottuLink deep link failed', data.error, data.originalURL);
        });
      } catch (error) {
        console.error('ChottuLink initialization failed', error);
      }
    })();
  },
};
